<template>
  <div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      resizable
      ref="editTableRef"
      :highlight-current-row="true"
      :header-row-class-name="tableHeaderClassName"
      :cell-style="tableCellStyle"
      :max-height="maxHeight()"
      class="tableBox"
      v-loading="loading"
    >
      <el-table-column
        type="index"
        fixed
        :index="indexMethod"
        label="编号"
        align="center"
        width="60"
      >
      </el-table-column>
      <el-table-column
        prop="realName"
        fixed
        label="客服"
        align="center"
        width="80"
        show-overflow-tooltip
      >
      </el-table-column>
      <!-- //70 -->
      <el-table-column prop="sort" label="排序" align="center" width="70"> 
        <template slot-scope="scope">
          <div class="sortBox">
            <img
              src="../../../static/quick/arrow_up.png"
              title="上移"
              v-if="scope.$index !== 0"
              @click="handleSortTable(scope.row, 'up', scope.$index)"
              alt=""
              style="float: left"
            />
            <!-- {{ scope.row.sort }} -->
            <img
              src="../../../static/quick/arrow_down.png"
              style="transform: rotate(180deg); float: right"
              title="下移"
              v-if="scope.$index !== tableData.length - 1"
              @click="handleSortTable(scope.row, 'down', scope.$index)"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="stress" label="权重" align="center" width="80">
      </el-table-column>
      <el-table-column
        prop="max"
        label="同时最大会话"
        width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="maxsessin"
        label="当日最大会话量"
        align="center"
        width="120"
      >
      </el-table-column>
      <el-table-column prop="sp" label="弹性上限" align="center">
        <template slot-scope="scope">
          <span>{{
            scope.row.sp === "" ? "" : scope.row.sp === "0" ? "关闭" : "开启"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="resouce" label="渠道" align="center" width="450">
        <template slot-scope="scope">
          <div class="channelCheckList">
            <span
              v-for="ch in channelOptions"
              :key="ch.value"
              class="channelCheckItem"
            >
              <span
                :class="[
                  'channelCheckBox',
                  { checked: rowHasChannel(scope.row, ch.value) },
                ]"
              >
                <i
                  v-if="rowHasChannel(scope.row, ch.value)"
                  class="el-icon-check"
                ></i>
              </span>
              <span
                class="channelTag"
                :style="{ backgroundColor: ch.bg, color: ch.color }"
                >{{ ch.label }}</span
              >
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="promotedAccounts"
        label="推广账户"
        align="center"
        width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-html="scope.row.aduserNames.join(' ')"></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="onlyAllocateAreas"
        label="区域（只分配）"
        align="center"
        width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span
            v-if="scope.row.isUseRegion"
            v-html="scope.row.autoRegionList.join(' ')"
          ></span>
          <span v-if="!scope.row.isUseRegion"></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="noAllocateAreas"
        label="区域（不分配）"
        width="120"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span
            v-if="scope.row.isUseRegion"
            v-html="scope.row.noAutoRegionList.join(' ')"
          ></span>
          <span v-if="!scope.row.isUseRegion"></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="onlyAllocateKeys"
        label="关键词（只分配）"
        width="150"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span
            v-if="scope.row.isUseKeyWord"
            v-html="scope.row.autoKeyWordList.join(' ')"
          ></span>
          <span v-if="!scope.row.isUseKeyWord"></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="noAllocateKeys"
        label="关键词（不分配）"
        width="150"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span
            v-if="scope.row.isUseKeyWord"
            v-html="scope.row.noAutoKeyWordList.join(' ')"
          ></span>
          <span v-if="!scope.row.isUseKeyWord"></span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100" align="center">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="editDialogTable(scope.row)"
            type="text"
            size="small"
          >
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 第二界面表格编辑弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="editDialogVisible"
      lock-scroll
      class="tableEditDialog"
      :close-on-click-modal="false"
      @close="handleEditDialogClose"
    >
      <template slot="title">
        <span class="el-dialog__title"
          >规则编辑（客服：{{ formData.realName }}）</span
        >
      </template>
      <el-form
        ref="editRuleForm"
        label-position="left"
        :rules="rules"
        :model="formData"
        :hide-required-asterisk="true"
      >
        <div class="tableEditDialog-title">分配会话 ：</div>
        <el-form-item
          prop="stress"
          class="tableEditDialog-item"
          label="会话权重 :"
        >
          <el-input
            v-model.number="formData.stress"
            style="width: 150px"
            size="mini"
            maxlength="3"
          ></el-input>
          <div class="tableEditDialog-text">
            范围1~10，默认1。权重越大分配越多。
          </div>
        </el-form-item>
        <div class="tableEditDialog-title">分配限制 ：</div>
        <el-form-item
          prop="max"
          class="tableEditDialog-item"
          label="同时最大会话 :"
        >
          <el-input
            v-model.number="formData.max"
            style="width: 150px"
            size="mini"
            maxlength="5"
          ></el-input>
          <div class="tableEditDialog-text">
            设置为0时，将不会有访客被分配进来。
          </div>
        </el-form-item>
        <el-form-item
          prop="maxsessin"
          class="tableEditDialog-item"
          label="当日最大会话量 :"
        >
          <el-input
            v-model.number="formData.maxsessin"
            style="width: 150px"
            size="mini"
            maxlength="5"
          ></el-input>
          <div class="tableEditDialog-text">设置为0时，则无最大数量限制。</div>
        </el-form-item>
        <el-form-item class="tableEditDialog-item">
          <el-checkbox
            v-model="formData.sp"
            @change="elasticSwitch"
            style="width: 150px; text-align: right"
            >开启弹性上限</el-checkbox
          >
          <span style="color: #969696; margin-left: 20px"
            >开启了弹性上限的成员可以继续分配。</span
          >
        </el-form-item>
        <div class="tableEditDialog-title">选择渠道 ：</div>
        <el-form-item prop="sources" class="tableEditDialog-item">
          <el-checkbox-group v-model="formData.sources">
            <el-checkbox
              v-for="(item, index) in sourceList"
              :key="index"
              :label="item.label"
            ></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <div class="tableEditDialog-title">推广账户 ：</div>
        <el-form-item prop="aduserNames" class="tableEditDialog-item">
          <el-select
            v-model="formData.aduserNames"
            multiple
            placeholder="请选择推广账号"
            size="mini"
            style="min-width: 6em"
          >
            <el-option
              v-for="(item, index) in adUserIdList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="tableEditDialog-title">区域规则 ：</div>
        <el-form-item
          prop="noAutoRegionList"
          class="tableEditDialog-item commonFlex"
        >
          <div style="flex: 1">
            <el-checkbox v-model="formData.isUseRegion"
              >勾选后进行区域规则匹配：</el-checkbox
            >
            <div style="width: 70%; color: black">
              <div class="title">只自动分配包含以下区域（用空格隔开）</div>
              <div>
                <el-input
                  v-if="formData.isUseRegion"
                  type="textarea"
                  cols="2"
                  v-model="formData.autoRegionList"
                  rows="6"
                  placeholder="请输入内容"
                ></el-input>
                <el-input
                  v-else
                  type="textarea"
                  cols="2"
                  rows="6"
                  v-model="formData.autoRegionList"
                  placeholder="请输入内容"
                  disabled
                ></el-input>
              </div>
            </div>
            <div style="width: 70%; color: black">
              <div class="title">从不自动分配包含以下区域（用空格隔开）</div>
              <div>
                <el-input
                  v-if="formData.isUseRegion"
                  type="textarea"
                  cols="2"
                  rows="6"
                  v-model="formData.noAutoRegionList"
                  placeholder="请输入内容"
                ></el-input>
                <el-input
                  v-else
                  type="textarea"
                  cols="2"
                  rows="6"
                  v-model="formData.noAutoRegionList"
                  placeholder="请输入内容"
                  disabled
                ></el-input>
              </div>
            </div>
          </div>
        </el-form-item>

        <div class="tableEditDialog-title">关键词规则 ：</div>
        <el-form-item
          prop="autoKeyWordList"
          class="tableEditDialog-item commonFlex"
        >
          <div style="flex: 1">
            <el-checkbox v-model="formData.isUseKeyWord"
              >勾选后进行关键词规则匹配：</el-checkbox
            >
            <div style="width: 70%; color: black">
              <div class="title">只自动分配包含以下关键词（用空格隔开）</div>
              <div>
                <el-input
                  v-if="formData.isUseKeyWord"
                  type="textarea"
                  cols="2"
                  rows="6"
                  v-model="formData.autoKeyWordList"
                  placeholder="请输入内容"
                ></el-input>
                <el-input
                  v-else
                  type="textarea"
                  cols="2"
                  rows="6"
                  v-model="formData.autoKeyWordList"
                  placeholder="请输入内容"
                  disabled
                ></el-input>
              </div>
            </div>
            <div style="width: 70%; color: black">
              <div class="title">从不自动分配包含以下关键词（用空格隔开）</div>
              <div>
                <el-input
                  v-if="formData.isUseKeyWord"
                  type="textarea"
                  cols="2"
                  rows="6"
                  placeholder="请输入内容"
                  v-model="formData.noAutoKeyWordList"
                ></el-input>
                <el-input
                  v-else
                  type="textarea"
                  cols="2"
                  rows="6"
                  placeholder="请输入内容"
                  disabled
                  v-model="formData.noAutoKeyWordList"
                ></el-input>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editDialogSave">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { maxHeight } from "../../utils/tableHeight";
export default {
  data() {
    var stressCheck = (rule, value, callback) => {
      console.log(this.formData.stress, typeof this.formData.stress);
      if (typeof this.formData.stress != "number") {
        callback(new Error("请输入数字"));
      } else {
        if (this.formData.stress <= 0 || this.formData.stress > 10) {
          callback(new Error("请输入1-10的整数"));
        } else {
          callback();
        }
      }
    };
    var maxCheck = (rule, value, callback) => {
      console.log(this.formData.max, typeof this.formData.max);
      if (typeof this.formData.max != "number") {
        callback(new Error("请输入数字"));
      } else {
        if (this.formData.max < 0) {
          callback(new Error("请输入大于等于0的正整数"));
        } else {
          callback();
        }
      }
    };
    var maxsessinCheck = (rule, value, callback) => {
      console.log(this.formData.maxsessin, typeof this.formData.maxsessin);
      if (typeof this.formData.maxsessin != "number") {
        callback(new Error("请输入数字"));
      } else {
        if (this.formData.maxsessin < 0) {
          callback(new Error("请输入大于等于0的正整数"));
        } else {
          callback();
        }
      }
    };

    // var noAutoRegionListCheck = (rule, value, callback) => {
    //   const data1= this.formData.noAutoRegionList
    //   const data2= this.formData.autoRegionList
    //   let arr1 = [...new Set(...that.formData[data1].trim().replace(/\s+/g, " ").split(" "))];
    //   let arr2 =[...new Set(...that.formData[data2].trim().replace(/\s+/g, " ").split(" "))];
    //   if(arr2.length>0){

    //   }
    //   if (){

    //   }else{
    //     callback();
    //   }
    // };
    return {
      tableData: [
        // {
        //   name: "客服",
        //   sort: "排序",
        //   weight: "权重",
        //   maxFlow: "同时最大流量",
        //   maxDialogue: "当日最大对话量",
        //   elasticUpperLimit: "弹性上限",
        //   channel: "渠道",
        //   promotedAccounts: "推广账户",
        //   onlyAllocateAreas: "",
        //   noAllocateAreas: "区域（不分配）",
        //   onlyAllocateKeys: "关键词（只分配）",
        //   noAllocateKeys: "关键词（不分配）",
        // }
      ],
      editDialogVisible: false,
      formData: {
        aduserNames: [],
        autoKeyWordList: [],
        autoRegionList: [],
        csid: "",
        loginName: "",
        max: "",
        maxsessin: "",
        noAutoKeyWordList: [],
        noAutoRegionList: [],
        promotedAccounts: [],
        sort: "",
        sources: [],
        sp: false,
        stress: "",
      },
      rules: {
        stress: [
          { required: true, message: "权重值不能为空" },
          { type: "number", message: "权重值必须为数字" },
          { validator: stressCheck, trigger: "blur" },
        ],
        max: [
          { required: true, message: "最大流量不能为空" },
          { type: "number", message: "最大流量必须为数字" },
          { validator: maxCheck, trigger: "blur" },
        ],
        maxsessin: [
          { required: true, message: "最大会话量不能为空" },
          { type: "number", message: "最大会话量必须为数字" },
          { validator: maxsessinCheck, trigger: "blur" },
        ],
        // noAutoRegionList: [
        //   { validator: noAutoRegionListCheck, trigger: "blur" },
        // ],
      },
      sourceList: [
        {
          label: "百度",
          value: 1,
        },
        {
          label: "360",
          value: 2,
        },
        {
          label: "搜狗",
          value: 3,
        },
        {
          label: "神马",
          value: 4,
        },
        {
          label: "快手",
          value: 7,
        },
        {
          label: "其他",
          value: 0,
        },
      ],

      // 渠道列展示用：顺序固定，后台数据变化不影响前端顺序（品牌色辅助识别）
      channelOptions: [
        { label: "百度", value: 1, bg: "#e8f3ff", color: "#2266dd" },
        { label: "360", value: 2, bg: "#e7f8ec", color: "#34a853" },
        { label: "搜狗", value: 3, bg: "#fff3e0", color: "#e6862c" },
        { label: "神马", value: 4, bg: "#e6f4ff", color: "#1890ff" },
        { label: "快手", value: 7, bg: "#ffece8", color: "#ff4d4f" },
        { label: "其他", value: 0, bg: "#f2f3f5", color: "#606266" },
      ],

      adUserIdList: [],
      checkAreaRule: true,
      keysAreaRule: true,
      loading: false,
    };
  },
  mounted() {
    this.getTableData();
    this.getPromotedAccounts();
  },

  methods: {
    //
    handleEditDialogClose() {
      console.log("talkCommon.vue handleEditDialogClose e:");
    },
    // 该行是否包含某个渠道（sources 里存的是渠道值）
    rowHasChannel(row, value) {
      const sources = row.sources || [];
      return sources.some((item) => Number(item) === value);
    },

    // 排序
    async handleSortTable(row, direction, $index) {


      const tempStree = row.stress;
      const tempSort = row.sort;
      let currentIndex = $index;
      if (direction === "up") {
        if (tempStree === this.tableData[currentIndex - 1].stress) {
          this.tableData[currentIndex].sort =
            this.tableData[currentIndex - 1].sort;
          this.tableData[currentIndex - 1].sort = tempSort;
        } else {
          this.$message.error("权重不一致");
          return;
        }
      } else {
        if (tempStree === this.tableData[currentIndex + 1].stress) {
          this.tableData[currentIndex].sort =
            this.tableData[currentIndex + 1].sort;
          this.tableData[currentIndex + 1].sort = tempSort;
        } else {
          this.$message.error("权重不一致");
          return;
        }
      }
      this.tableData.sort((a, b) => {
        if (a.stress !== b.stress) {
          // 按照 stress 属性进行升序
          return b.stress - a.stress;
        } else {
            // 按照 sort 属性进行降序
          return a.sort - b.sort;
        }
      });
      let arr = [];
      this.tableData.forEach((item) => {
        arr.push({
          sort: item.sort,
          csid: item.csid,
        });
      });
      this.$refs.editTableRef.doLayout();
      var api = "/manager/user/saveSortNumber";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: arr,
      });
      if (response.resultCode == 10000) {
        console.log("talkCommon.vue handleSortTable tableData", this.tableData);
      } else {
        this.$message.error(response.desc);
      }
    },

    // 获取表格数据
    async getTableData() {
      this.loading = true;
      var api = "/manager/sessStgyRegion/listAllocationRules";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {},
      });
      if (response.resultCode == 10000) {
        this.tableData = response.data;

        // this.tableData.forEach((item, index) => {
        //   item.sortIndex = index + 1;
        // });
        // localStorage.setItem("sessionRuleTable", this.tableData);
        console.log("TalkCommon.vue getTableData tableData", this.tableData);
      } else {
        this.$message.error(response.desc);
      }
      this.loading = false;
    },
    
    maxHeight,
    // 获取推广账号列表
    async getPromotedAccounts() {
      var api = "/manager/aduserRelation/selectList";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {},
      });
      if (response.resultCode == 10000) {
        this.adUserIdList = [];
        response.data.forEach((item) => {
          this.adUserIdList.push({
            value: item.aduserId,
            label: item.aduserName,
          });
        });
        console.log(
          "TalkCommon.vue getPromotedAccounts this.adUserIdList ",
          this.adUserIdList
        );
      } else {
        this.$message.error(response.desc);
      }
    },
    // 弹性上限开关
    elasticSwitch(blo) {
      this.formData.elasticUpperLimit = blo;
    },

    // 根据csid获取id
    async getId(csid) {
      var api = "/manager/sessStgyGeneral/selectById";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          csid,
        },
      });
      if (response.resultCode == 10000) {
        if (response.data.data == null) {
          return "";
        } else {
          return response.data.data.id;
        }
      } else {
        this.$message.error(response.desc);
      }
    },

    // 文字去重
    textDeduplication(arr) {
      return [...new Set([...arr])];
    },
    // 保存表格
    editDialogSave() {
      this.$refs.editRuleForm.validate(async (valid) => {
        const that = this;
        if (valid) {
          console.log("talkCommon.vue editDialogSave formData:", this.formData);
          const csid = this.formData.csid;
          const max = this.formData.max;
          const stress = this.formData.stress;
          const maxsessin = this.formData.maxsessin;
          const sp = this.formData.sp === true ? "1" : "0";
          const isUseKeyWord = this.formData.isUseKeyWord;
          const isUseRegion = this.formData.isUseRegion;
          // 推广账号
          const autoAdUserList = this.formData.aduserNames;
          // 渠道
          let channel = [];
          // 区域
          let autoContentList = [];
          //非区域
          let noAutoContentList = [];
          // 关键词
          let autokeyWordList = [];
          // 非关键词
          let noAutokeyWordList = [];
          let arr = [];
          this.formData.sources.forEach((item) => {
            if (item == "其他") {
              arr.push(0);
            } else if (item == "百度") {
              arr.push(1);
            } else if (item == "360") {
              arr.push(2);
            } else if (item == "搜狗") {
              arr.push(3);
            } else if (item == "神马") {
              arr.push(4);
            } else if (item == "快手") {
              arr.push(7);
            }
          });
          channel = arr;

          autoContentList = strToSpeArr("autoRegionList", 0);
          noAutoContentList = strToSpeArr("noAutoRegionList", 0);
          autokeyWordList = strToSpeArr("autoKeyWordList", 1);
          noAutokeyWordList = strToSpeArr("noAutoKeyWordList", 1);

          const id = await this.getId(csid);
          const opts = {
            sessStgyGeneral: {
              id,
              csid,
              max,
              stress,
              maxsessin,
              sp,
            },
            sessStgySource: {
              csid,
              autoContentList: channel,
            },
            sessStgyAduser: {
              csid,
              autoAdUserList,
            },
            sessStgyRegion: {
              csid,
              isUse: isUseRegion,
              autoContentList,
              noAutoContentList: noAutoContentList,
            },
            sessStgyKeyWord: {
              csid: csid,
              isUse: isUseKeyWord,
              autokeyWordList,
              noAutokeyWordList,
            },
          };
          console.log("talkCommon.vue editDialogTable opts:", opts);
          var api = "/manager/sessStgyGeneral/saveList";
          const response = await this.util.postRequest({
            url: api,
            method: "POST",
            data: opts,
          });
          if (response.resultCode == 10000) {
            this.getTableData();
            this.editDialogVisible = false;
            this.$message.success("保存成功");
          } else {
            this.$message.error(response.desc);
          }

          // 验证成功
        } else {
          this.$message.error("请按照规则填写！");
          // 验证失败
          return false;
        }
        function strToSpeArr(str, param) {
          let arr = [];
          let arr2 = that.formData[str].trim().replace(/\s+/g, " ").split(" ");
          arr2 = that.textDeduplication(arr2);
          if (param === 0) {
            arr2.forEach((item) => {
              arr.push({
                content: item,
              });
            });
          } else {
            arr2.forEach((item) => {
              arr.push({
                keyWord: item,
              });
            });
          }
          return arr;
        }
      });
    },
    //  编辑表格
    editDialogTable(row) {
      let data = JSON.parse(JSON.stringify(row));
      data.stress = data.stress === "" ? "" : Number(data.stress);
      data.max = data.max === "" ? "" : Number(data.max);
      data.maxsessin = data.maxsessin === "" ? "" : Number(data.maxsessin);
      data.sp = data.sp === "" ? "" : data.sp === "0" ? false : true;
      let arr = [];
      data.sources.forEach((item) => {
        if (item == 0) {
          arr.push("其他");
        } else if (item == 1) {
          arr.push("百度");
        } else if (item == 2) {
          arr.push("360");
        } else if (item == 3) {
          arr.push("搜狗");
        } else if (item == 4) {
          arr.push("神马");
        } else if (item == 7) {
          arr.push("快手");
        }
      });
      data.sources = arr;
      let arr2 = [];
      console.log(
        "---------------------- this.adUserIdList：",
        this.adUserIdList
      );
      this.adUserIdList.forEach((item) => {
        const index = data.aduserNames.indexOf(item.label);
        if (index !== -1) {
          arr2.push(item.value);
        }
      });
      data.aduserNames = arr2;
      data.autoRegionList = data.autoRegionList.join(" ");
      data.noAutoRegionList = data.noAutoRegionList.join(" ");
      data.autoKeyWordList = data.autoKeyWordList.join(" ");
      data.noAutoKeyWordList = data.noAutoKeyWordList.join(" ");
      this.formData = data;
      console.log("talkCommon.vue editDialogTable formData:", this.formData);
      this.editDialogVisible = true;
    },
    // 表格单元格样式
    tableCellStyle() {
      return "text-align:center";
    },
    // 表格表头样式
    tableHeaderClassName() {
      return "tableHeaderClass";
    },
    // 表格索引
    indexMethod(index) {
      return index + 1;
    },
  },
  // watch: {
  //   tableData: {

  //   },
  // },
};
</script>

<style lang="scss" scoped>
::v-deep  .el-table {
  width: 100%;
  table-layout: auto;

  min-width: 0;
  .el-table__cell {
    padding: 0;
  }
  .cell {
    white-space: nowrap;
  }

  .tableHeaderClass th:first-child {
    min-width: 60px;
    // white-space: nowrap;
  }
  .tableHeaderClass {
    color: #000 !important;
    font-weight: 600;
    @include change_size($font_size_normal);
  }
  .sortBox {
    text-align: center;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    img {
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
  }

  // 渠道列：固定顺序勾选 + 品牌色标签
  .channelCheckList {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 8px;
    padding: 4px 0;
  }
  .channelCheckItem {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }
  .channelCheckBox {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    border: 1px solid #dcdfe6;
    border-radius: 2px;
    background: #fff;
    box-sizing: border-box;
    flex-shrink: 0;

    .el-icon-check {
      font-size: 12px;
      color: #fff;
      font-weight: 700;
    }

    &.checked {
      background: #409eff;
      border-color: #409eff;
    }
  }
  .channelTag {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 12px;
    font-size: 12px;
    line-height: 16px;
    white-space: nowrap;
  }
}

// 表格编辑弹出窗样式
::v-deep .tableEditDialog {
  .el-dialog {
    width: fit-content !important;
  }
  .el-form-item__label {
    text-align: right;
    // margin-left: 2em;
    min-width: 150px;
  }
  .tableEditDialog-item {
    display: flex;
    .tableEditDialog-text {
      margin-left: 10px;
      line-height: 40px;
      color: #969696;
      font-size: 14px;
    }
  }

  .el-form-item__content {
    display: flex;
    .el-input {
      margin-left: 0 !important;
    }
  }
  .el-dialog__body {
    max-height: 60vh;
    overflow-y: auto;
  }
  .el-dialog__title::before {
    display: block;
    content: "";
    width: 3px;
    height: auto;
    background-color: #1577d2;
    margin-right: 6px;
  }

  .el-dialog__title {
    display: flex;
    color: #000;
    font-weight: 600;
    line-height: 1;
    @include change_title_size($title_size_normal);
  }
  .el-dialog__footer {
    text-align: center;
  }
  .tableEditDialog-title {
    font-weight: 600;
    color: #000;
    @include change_title_size($title_size_normal);
  }
}
</style>
